import React, { useState } from 'react';
import { registerUser } from '../firebase';

export default function Register({ onSwitch, onHome }) {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    businessName:'', ownerName:'', email:'', password:'', confirmPassword:'',
    phone:'', address:'', city:'', country:'', currency:'$', taxNumber:''
  });

  const update = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const nextStep = () => {
    if (!form.businessName.trim()) { setError('Please enter business name'); return; }
    if (!form.email.trim()) { setError('Please enter email'); return; }
    if (!form.phone.trim()) { setError('Please enter phone number'); return; }
    if (form.password.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (form.password !== form.confirmPassword) { setError('Passwords do not match'); return; }
    setError(''); setStep(2);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await registerUser(form.email, form.password, {
        businessName: form.businessName, ownerName: form.ownerName,
        phone: form.phone, address: form.address, city: form.city,
        country: form.country, currency: form.currency, taxNumber: form.taxNumber,
      });
    } catch (err) {
      setError(err.message.includes('email-already-in-use') ? 'This email is already registered.' : 'Registration failed. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(135deg, #0f6e56 0%, #1d9e75 100%)', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'#fff', borderRadius:20, padding:40, width:'100%', maxWidth:480, boxShadow:'0 20px 60px rgba(0,0,0,0.15)' }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:24, fontWeight:700, color:'#0f6e56' }}>FinlyBooks</div>
          <div style={{ fontSize:13, color:'#888', marginTop:2 }}>Create your free account</div>
        </div>

        <div style={{ display:'flex', gap:8, marginBottom:24 }}>
          {[1,2].map(n => (
            <div key={n} style={{ flex:1, height:4, borderRadius:2, background: step >= n ? '#0f6e56' : '#e8e8e8', transition:'background 0.3s' }} />
          ))}
        </div>

        {step === 1 && (
          <div>
            <div style={{ fontSize:15, fontWeight:600, color:'#222', marginBottom:16 }}>Business details</div>
            <Field label="Business Name *" value={form.businessName} onChange={v => update('businessName', v)} placeholder="e.g. Sunrise Store" />
            <Field label="Owner Name" value={form.ownerName} onChange={v => update('ownerName', v)} placeholder="e.g. John Smith" />
            <Field label="Email *" type="email" value={form.email} onChange={v => update('email', v)} placeholder="info@yourbusiness.com" />
            <Field label="Phone *" value={form.phone} onChange={v => update('phone', v)} placeholder="+1 555 000 0000" />
            <Field label="Password *" type="password" value={form.password} onChange={v => update('password', v)} placeholder="Min 6 characters" />
            <Field label="Confirm Password *" type="password" value={form.confirmPassword} onChange={v => update('confirmPassword', v)} placeholder="Repeat password" />
            {error && <ErrBox msg={error} />}
            <button onClick={nextStep} style={btnStyle}>Continue →</button>
          </div>
        )}

        {step === 2 && (
          <form onSubmit={handleRegister}>
            <div style={{ fontSize:15, fontWeight:600, color:'#222', marginBottom:16 }}>Business address & settings</div>
            <Field label="Address" value={form.address} onChange={v => update('address', v)} placeholder="Street address" />
            <Field label="City" value={form.city} onChange={v => update('city', v)} placeholder="e.g. Kingston" />
            <Field label="Country" value={form.country} onChange={v => update('country', v)} placeholder="e.g. Jamaica" />
            <Field label="Tax / VAT Number" value={form.taxNumber} onChange={v => update('taxNumber', v)} placeholder="Optional" />
            <div style={{ marginBottom:16 }}>
              <label style={labelStyle}>Currency</label>
              <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                {['$','£','€','₹','AED','JMD'].map(c => (
                  <button key={c} type="button" onClick={() => update('currency', c)} style={{
                    padding:'6px 14px', borderRadius:8, border:`1.5px solid ${form.currency === c ? '#0f6e56' : '#ddd'}`,
                    background: form.currency === c ? '#0f6e56' : '#fff', color: form.currency === c ? '#fff' : '#555',
                    fontWeight:600, cursor:'pointer', fontSize:14
                  }}>{c}</button>
                ))}
              </div>
            </div>
            <div style={{ background:'#e1f5ee', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#085041', marginBottom:16 }}>
              🛡️ By registering you agree to receive product updates from FinlyBooks via email and WhatsApp.
            </div>
            {error && <ErrBox msg={error} />}
            <div style={{ display:'flex', gap:10 }}>
              <button type="button" onClick={() => setStep(1)} style={{ ...btnStyle, background:'#fff', color:'#0f6e56', border:'1.5px solid #0f6e56', flex:1 }}>← Back</button>
              <button type="submit" disabled={loading} style={{ ...btnStyle, flex:2 }}>{loading ? 'Creating account...' : 'Start FinlyBooks free'}</button>
            </div>
          </form>
        )}

        <div style={{ textAlign:'center', marginTop:20, fontSize:13, color:'#888' }}>
          Already have an account?{' '}
          <button onClick={onSwitch} style={{ background:'none', border:'none', color:'#0f6e56', fontWeight:600, cursor:'pointer' }}>Sign in</button>
        </div>
        <div style={{ textAlign:'center', marginTop:16, fontSize:11, color:'#aaa' }}>© 2025 FinlyBooks · www.finlybooks.com</div>
        {onHome && <div style={{ textAlign:'center', marginTop:12 }}><button onClick={onHome} style={{ background:'none', border:'none', color:'#888', cursor:'pointer', fontSize:13 }}>← Back to home</button></div>}
      </div>
    </div>
  );
}

function Field({ label, type='text', value, onChange, placeholder }) {
  return (
    <div style={{ marginBottom:14 }}>
      <label style={labelStyle}>{label}</label>
      <input style={inputStyle} type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} />
    </div>
  );
}

function ErrBox({ msg }) {
  return <div style={{ background:'#fcebeb', color:'#a32d2d', padding:'10px 14px', borderRadius:8, fontSize:13, marginBottom:14 }}>{msg}</div>;
}

const labelStyle = { display:'block', fontSize:13, fontWeight:500, color:'#555', marginBottom:6 };
const inputStyle = { width:'100%', padding:'11px 14px', border:'1px solid #ddd', borderRadius:10, fontSize:14, color:'#222', outline:'none', background:'#fafafa' };
const btnStyle = { width:'100%', padding:14, background:'#0f6e56', color:'#fff', border:'none', borderRadius:10, fontSize:15, fontWeight:700, cursor:'pointer' };
